<!--
 * @Description: 照片直播
 * @Date: 2020-01-12
 -->
<template>
    <div id="signUpInfo">
        <div class="signUpInfo_container">
            <div class="nav" v-if="navShow">
                <a :href="navhomeUrl" target="_top">首页</a>
                > <a>照片直播</a>
            </div>
            <div class="banner-img" ref="bannerHieght" v-if="meetingInfo.MobileBannerImage!=null&&red!='im'">
                <img :src="meetingInfo.MobileBannerImage">
            </div>
            <div class="signUpInfo_content clearfix">
              <div class="signUpInfo_left" :class="{'siderbar':siderbarShow}" :style="{top: topNum+'px'}">
                <div class="meeting-list" 
                  v-for="(item,index) in photoClass" 
                  :key='index' 
                  :class="{'active':active==index}"
                  @click="toDetail(index)">
                    {{item.cname}}
                    <span>({{item.photonums}})</span>
                </div>
              </div>
              <div class="signUpInfo_right">
                  <div v-if="photoDetail.Photos!=null && photoDetail.Photos.length>0">
                      <div class="schedule-meeting">
                          <div class="meeting-list" 
                              v-for="(item,index) in photoDetail.Photos" :key='index'
                              @click="bigImg(index)">
                              <img :src="item.oimage">
                          </div>
                      </div>
                  </div>
                  <!-- <div class="noDate" v-else>
                      暂无图片
                  </div> -->
              </div>
            </div>
        </div>
        <div class="gotop" @click="goTopFun()" v-if="btnFlag"> 
            <img src="../../assets/goTop.png">
        </div>
        
        <div class="pop-ups" v-show="popShow">
            <div class="pop-colse" @click="closePup">
                <img src="../../assets/close.png">
            </div>
            <div class="pop-main">
                <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide v-for="(item,index) in photoDetail.Photos" :key='index'>
                        <div class="swiper-zoom-container">
                            <img :src="item.oimage" v-if="!item.disable">
                            <img :src="item.redimage" v-if="item.disable">
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-prev" @click="prev"></div>
                <div class="swiper-button-next" @click="next"></div>
            </div>
            <div class="pop-foot">
                <div class="pop-btn">
                    <span>{{nowNumber}}</span>/<span>{{photoDetail.photonums}}</span>
                </div>
                <div class="pop-btn" @click="getMore()">
                    {{getMoreText}}
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import { initMeetingInfo, getGetPhotoClass, getPhotoInfo, getPhotoPageInfo } from "@/api/modules/live/index.dto";
import { IMeetingInfo,current } from "@/contants/current";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Footer from "../../components/Footer.vue";
export default {
    name: 'photoList',
    components: { 
      Footer,
      swiper, 
      swiperSlide 
    },
    data() {
        return {
            params: {
                m: '',
                red: '',
                clid: '',
            },
            meetingInfo: '',
            show: false,
            loading: false,
            photoClass: [],
            clid: '',
            photoDetail: '',
            active: 0,
            red: '',
            navShow: true,
            navhomeUrl: '',
            popShow: false,
            nowNumber: 1,
            swiperOptions: {
                observer: true,
                observeParents: true,
                initialSlide: 0,
                zoom: true, 
                fade: {
                  crossFade: true,
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
            },
            require: true,
            isbottom: 0,
            currentPage: 2,
            getMoreText: '查看原图',
            scrollTop: '',
            btnFlag: false,
            nowPhotoDetail: '',
            topNum: 40,
            scroll: '',
            height: 0,
            siderbarShow: false,
        }
    },
    created() {
        this.params = this.$route.query
        this.red = this.params.red
        let opt = { m: this.params.m }
        this.current = new current();
        let _isMobile = this.current.is_Mobile();
        if (_isMobile) {
            let _params = window.location.href.split("?")[1];
            window.location.href = `https://mp.weiqihd.com/mpweb/#/photoList?${_params}`;
        }
		this.initMeetingInfo();
        this.initmeeting(opt)
        this.init(opt)
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        },
    },
    mounted() {
        let that = this
        that.swiper.on("transitionEnd", function() {
            if (that.swiper.swipeDirection == 'next') {
                if (that.swiper.activeIndex >= ((that.currentPage - 1) * 10 - 1) && that.require) {
                    that.getPhotoPageInfo()
                }
            }
            that.nowNumber = that.swiper.activeIndex + 1;
            that.photoDetail.Photos[that.nowNumber-1].disable = false
            that.getMoreText = '查看原图'
        });
        window.addEventListener('scroll', this.scrollEvent, true)
    },
    methods: {
		async initMeetingInfo() {
			let params = {
				m: this.params.m
			};
			let res = await IMeetingInfo.InitMeetingInfo(params);
		},
        prev() {
            this.$refs.mySwiper.swiper.slidePrev();
            console.log(this.swiper.activeIndex)
            this.nowNumber = this.swiper.activeIndex + 1;
            this.photoDetail.Photos[this.nowNumber-1].disable = false
            this.getMoreText = '查看原图'
            
        },
        next() {
            this.$refs.mySwiper.swiper.slideNext();
            this.nowNumber = this.swiper.activeIndex + 1;
            this.photoDetail.Photos[this.nowNumber-1].disable = false
            this.getMoreText = '查看原图'
            if (this.swiper.activeIndex >= ((this.currentPage - 1) * 10 - 1) && this.require) {
              this.getPhotoPageInfo()
            }
        },
        async initmeeting(opt) {
            let that = this
            this.show = true
            this.meetingInfo = await this.$http.live.GetAPIProgram(opt);
            if (this.meetingInfo.Code === 1000) {
                this.show = false
                that.$nextTick(() => {
                  if( that.meetingInfo.MobileBannerImage!=null && that.red!='im'){
                    that.height = that.$refs.bannerHieght.offsetHeight;
                  }
                  //console.log(that.height)
                  if (that.meetingInfo.HomeUrl == null || that.meetingInfo.HomeUrl == '') {
                      that.navShow = false
                  } else {
                      that.navShow = true
                      that.navhomeUrl = that.meetingInfo.HomeUrl
                  }
                })
            } else {
                this.$notify({
                    massage: this.meetingInfo.Msg,
                    type: 'danger',
                    duration: '3000',
                })
            }
        },
        /**
         * 初始化数据
         */
        async init(opt) {
            try {
                this.loading = true
                let res = await this.$http.live.GetPhotoClass(opt);
                //console.log(res)
                this.loading = false
                this.photoClass = res
                if (this.photoClass != null && this.photoClass.length > 0) {
                  let number = 0
                  for( let i in this.photoClass){
                    //console.log(this.params.clid)
                    if( this.params.clid == this.photoClass[i].clid ){
                      this.active = i
                      //console.log(i)
                    }else{
                      number++
                    }
                  }
                  if( number == this.photoClass.length){
                    this.active = 0
                  }
                  //console.log(this.active)
                  this.clid = this.photoClass[this.active].clid
                  this.photoInfo()
                }
            } catch (err) {
                console.log(err)
            }
        },

        async photoInfo() {
            let opts = {
              m: this.params.m,
              clid: this.clid
            }
            try {
                let res = await this.$http.live.GetPhotoInfo(opts);
                console.log(res)
                this.photoDetail = res
            } catch (err) {
                console.log(err)
            }
        },
        //分页加载
        async getPhotoPageInfo(){
            let that = this
            let opt = {
                m:  this.params.m,
                clid: this.clid,
                page: this.currentPage,
            }
            try {
                this.loading = true
                let res = await this.$http.live.GetPhotoPageInfo(opt);
                console.log(that.photoDetail)
                this.loading = false
                this.nowPhotoDetail = res
                if ( res.length > 0 ) {
                    that.photoDetail.Photos = that.photoDetail.Photos.concat(res)
                    for( let i in that.photoDetail.Photos ){
                        that.$set(that.photoDetail.Photos[i], 'disable', false)
                    }
                    //console.log(that.photoDetail.Photos)
                    that.swiper.update()
                }
                if( res.length < 10){
                    that.require = false;
                }else{
                    that.currentPage++
                }
                that.$nextTick(() => {
                    that.require = true;
                    if( that.nowPhotoDetail.length < 10 ){
                        that.require = false;
                        that.isbottom = 1
                    }
                })
            } catch (err) {
                console.log(err)
            }
        },
        //滚动加载
        scrollEvent(e) {
            let that = this
            //let scrollTop = e.srcElement.scrollTop || e.srcElement.scrollTop
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > (40 + that.height)) {
                that.btnFlag = true
                that.siderbarShow = true
                that.topNum = 40
            } else {
                that.btnFlag = false
                that.siderbarShow = false
            }
            that.scroll = e
            //console.log(window.screen.height,document.documentElement.scrollTop,document.body.clientHeight,this.require)
            if ( window.screen.height + document.documentElement.scrollTop + 100 > document.body.clientHeight  &&  this.require) {
            //if ( e.srcElement.scrollTop + e.srcElement.offsetHeight + 100 > e.srcElement.clientHeight  &&  this.require) {
                this.require = false;
                this.isbottom = -1
                //console.log(that.currentPage)
                that.getPhotoPageInfo()
            }
        },
        goTopFun(){
            //this.scroll.target.scrollTop = 0;
            let that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                  clearInterval(timer)
                }
            }, 16)
        },
        bigImg(index){
            this.popShow = true
            this.nowNumber = index + 1
            this.swiper.slideTo(index, 0, false);       
        },
        getMore(){
            this.photoDetail.Photos[this.nowNumber-1].disable = true
            this.getMoreText = '已加载'
        },
        closePup(){
            this.popShow = false
        },
        toDetail(index) {
            let that = this
            this.active = index
            this.clid = this.photoClass[this.active].clid
            this.goTopFun()
            this.photoDetail.Photos = []
            this.photoInfo()
            this.require = true
            this.currentPage = 2
        },
    },
}
</script>
<style lang="scss" scoped>
.pop-ups{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-height: 100%;
    background: rgba(0,0,0,1);
    background-image: url(../../assets/bg_black.png);
    background-size: contain;
    z-index: 500;
    color: #fff;
    .pop-colse{
        position: absolute;
        right: 50px;
        top: 40px;
        z-index: 502;
        width: 40px;
        height: 40px;
        cursor: pointer;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .pop-main{
        position: absolute;
        left: 100px;
        right: 100px;
        top: 100px;
        bottom: 100px;
        z-index: 501;
        display: flex;
        justify-content: center;
        align-items: center;
        .swiper-container,.swiper-zoom-container{
            width: 100%;
            height: 100%;
            display: flex;
          justify-content: center;
          align-items: center;
        }
        img{
            max-width: 100%;
            max-height: 100%;
        }
        .swiper-zoom-container > img{
            object-fit: initial !important;
        }
    }
    .pop-foot{
        position: absolute;
        right: 50px;
        left: 50px;
        bottom: 40px;
        height: 40px;
        z-index: 502;
        display: flex;
        justify-content: space-between;
        .pop-btn{
            background: rgba(0,0,0,.5);
            border: 1px solid hsla(0,0%,100%,.2);
            padding: 0 30px;
            font-size: 16px;
            line-height: 38px;
            cursor: pointer;
        }
    }
}
.signUpInfo-banner {
    width: 100%;
    overflow: hidden;
    position: relative;
}

.signUpInfo-banner .swiper-slide {
    position: relative;
    text-align: center;
}

.signUpInfo-banner img {
    max-width: 100%;
    display: block;
}

.commonW {
    width: 100%;
    margin: 0 auto;
}

// ----------
#signUpInfo {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    // position: absolute;
    // left: 0;
    // right: 0;
    // bottom: 110px;
    // top: 0;
    .signUpInfo_container {
        padding-bottom: 70px;
        .signUpInfo_content{
          width: 1200px;
          margin: 0 auto;
          padding-top: 20px;
          .signUpInfo_left{
            width: 220px;
            float: left;
            // left: 10px;
            // right: 0;
            // bottom: 0;
            //top: 30px;
            // overflow-y: auto;
            .meeting-list{
              padding: 12px 8px;
              line-height: 22px;
              font-size: 14px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: space-between;
              img{
                width: 20px;
              }
            }
            .meeting-list.active{
              color: #fff;
              background: linear-gradient(135deg, #3b82f6, #6366f1);
            }
          }
          .signUpInfo_left.siderbar{
            position: fixed;
            bottom: 50px;
            overflow-y: auto;
          }
          .signUpInfo_right{
            // position: absolute;
            // left: 250px;
            // right: 0;
            // bottom: 10px;
            // top: 30px;
            // overflow-y: auto;
            float: right;
            width: 950px;
            padding-left: 30px;
            .schedule-meeting{
              display: flex;
              flex-wrap: wrap;
              .meeting-list{
                width: 460px;
                height: 240px;
                border-bottom: 1px solid #000;
                border-right: 1px solid #000;
                box-sizing: border-box;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
              }

              .meeting-list:nth-child(2n){
                  border-right: none;
              }
            }
          }
        }
        .noDate {
            text-align: center;
            padding: 20px;
            font-size: 26px;
            color: #666;
        }
        .note {
            text-align: center;
            font-size: 22px;
            color: #999;
            margin-top: 20px;
        }
    }
}



.nav {
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    background: #3b82f6 url(../../assets/home.png) no-repeat 10px center;
    background-size: 26px 26px;
    color: #fff;
    padding: 0 20px 0 40px;

    a {
        color: #fff;
    }
}

.banner-img img {
    width: 100%;
}

#foot {
    position: fixed;
    width: 1200px;
    height: 30px;
    text-align: center;
    bottom: 0;
    border-top: 1px solid #e6e6e6;
    background: #f5f5f5;
    padding: 10px;
    color: #999;
    line-height: 30px;
    margin: 0 auto;
}

#foot img {
    display: inline-block;
    vertical-align: top;
    height: 30px;
    margin-right: 10px;
}
.gotop{
    position: fixed;
    right: 100px;
    bottom: 60px;
    z-index: 100;
    background: #fff;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    img{
        width: 100%;
        height: 100%;
    }
}
.clearfix {
    *zoom: 1;
}

.clearfix:after {
    content: '\20';
    display: block;
    height: 0;
    clear: both;
}

</style>